import { render, staticRenderFns } from "./CompanyReferer.vue?vue&type=template&id=0788d7ce&scoped=true&"
import script from "./CompanyReferer.vue?vue&type=script&lang=js&"
export * from "./CompanyReferer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788d7ce",
  null
  
)

export default component.exports